import {
  StyledScrollSection,
  StyledSection,
} from '@components/layouts/Layouts';
import {
  ButtonNormalSecondarySmallCompact,
  DividerHorizontal,
  RowCenterBetween,
  TextHeading2,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';

import { usePublicationAvailableGlobalList } from '@modules/publications/publications.store';
import { PublicationsAvailableGlobalList } from '@modules/publications/PublicationsAvailableGlobalList';

export const HomeGlobalSection = () => {
  const { isLoading, isEmpty } = usePublicationAvailableGlobalList();

  if (isLoading || isEmpty) {
    return null;
  }

  return (
    <>
      <StyledSection>
        <DividerHorizontal />

        <RowCenterBetween>
          <TextHeading2>Disponíveis em todo Brasil</TextHeading2>

          <LinkWrapper href="/publications?is_global=true">
            <ButtonNormalSecondarySmallCompact>
              Ver todos
            </ButtonNormalSecondarySmallCompact>
          </LinkWrapper>
        </RowCenterBetween>
      </StyledSection>

      <StyledScrollSection>
        <PublicationsAvailableGlobalList />
      </StyledScrollSection>
    </>
  );
};
